<template>
    <div class="center-box">
        <div class="wrap" v-if="userInfo.userType == 2 || dataObj.approvalStatus || dataObj.approvalStatus == 0">
            <el-button size="mini" class="topBtn" type="primary" plain v-if="dataObj.approvalStatus == 1"
                @click="edit">编辑</el-button>
            <el-button size="mini" class="topBtn" type="primary" plain v-if="dataObj.approvalStatus == 2"
                @click="edit">再次申请</el-button>
            <div class="topBox">
                <div class="topBox-p">
                    <div class="p1">姓名：</div>
                    <div class="p2">{{ dataObj.realName }}</div>
                    <div class="p3" v-if="dataObj.approvalStatus == 0">
                        <img class="img1" src="../../assets/img/daishenhe2.png" alt="">
                    </div>
                    <div class="p4" v-if="dataObj.approvalStatus == 1">
                        <img class="img1" src="../../assets/img/daishenhe.png" alt="">
                    </div>
                    <div class="p5" v-if="dataObj.approvalStatus == 2">
                        <img class="img1" src="../../assets/img/weitongguo.png" alt="">
                    </div>
                </div>
                <div class="topBox-p">
                    <div class="p1">性别：</div>
                    <div class="p2">{{ dataObj.sex }}</div>
                </div>
                <div class="topBox-p">
                    <div class="p1">身份证号：</div>
                    <div class="p2">{{ dataObj.card }}</div>
                </div>
                <div class="topBox-p">
                    <div class="p1">手机号码：</div>
                    <div class="p2">{{ dataObj.phone }}</div>
                </div>
                <div class="topBox-p">
                    <div class="p1">邮箱：</div>
                    <div class="p2">{{ dataObj.email }}</div>
                </div>
                <div class="topBox-p">
                    <div class="p1">医师证号：</div>
                    <div class="p2">{{ dataObj.physicianCardNum }}</div>
                </div>
                <div class="topBox-p">
                    <div class="p1">擅长科室：</div>
                    <div class="p2">{{ dataObj.adeptDepartments }}</div>
                </div>
                <div class="topBox-p">
                    <div class="p1">所属医院：</div>
                    <div class="p2">{{ dataObj.hospital }}</div>
                </div>
                <div class="topBox-p">
                    <div class="p1">科室：</div>
                    <div class="p2">{{ dataObj.department }}</div>
                </div>
                <div class="topBox-p">
                    <div class="p1">职称：</div>
                    <div class="p2">{{ dataObj.title }}</div>
                </div>
                <div class="topBox-p">
                    <div class="p1">简介：</div>
                    <div class="p2">{{ dataObj.introduceMyself }}</div>
                </div>
                <div class="topBox-p">
                    <div class="p1">经营地址：</div>
                    <div class="p2">{{ dataObj.cityRegion + ',' + dataObj.address }}</div>
                </div>
                <div class="topBox-p org" v-if="dataObj.approvalStatus == 2">
                    <div class="p1">未通过原因：</div>
                    <div class="p2">{{ dataObj.opinion }}</div>
                </div>
            </div>
            <div class="centerBox">
                <div class="p1">有效证件：</div>
                <div class="p2">
                    <div class="imgWs">
                        <div class="imgW" v-if="dataObj.cardFront">
                            <div class="imgs" @click="bigImg(dataObj.cardFront)">
                                <img :src="$store.state.imgUrl + dataObj.cardFront" alt="">
                            </div>
                            <div class="imgTxt">身份证-人像面</div>
                        </div>
                        <div class="imgW" v-if="dataObj.cardReverse">
                            <div class="imgs" @click="bigImg(dataObj.cardReverse)">
                                <img :src="$store.state.imgUrl + dataObj.cardReverse" alt="">
                            </div>
                            <div class="imgTxt">身份证-国徽面</div>
                        </div>
                        <div class="imgW" v-if="dataObj.peopleCardFront">
                            <div class="imgs" @click="bigImg(dataObj.peopleCardFront)">
                                <img :src="$store.state.imgUrl + dataObj.peopleCardFront" alt="">
                            </div>
                            <div class="imgTxt">手持身份证正面照片</div>
                        </div>
                        <div class="imgW" v-if="dataObj.peopleCardReverse">
                            <div class="imgs" @click="bigImg(dataObj.peopleCardReverse)">
                                <img :src="$store.state.imgUrl + dataObj.peopleCardReverse" alt="">
                            </div>
                            <div class="imgTxt">手持身份证反面照片</div>
                        </div>
                        <div v-if="physicianCardImgList">
                            <div class="imgW" v-for="(item, index) in physicianCardImgList" :key="index">
                                <div class="imgs" @click="bigImg(item)">
                                    <img :src="$store.state.imgUrl + item" alt="">
                                </div>
                                <div class="imgTxt">医师证照片{{ index + 1 }}</div>
                            </div>
                        </div>
                        <div class="imgW" v-if="dataObj.picture">
                            <div class="imgs" @click="bigImg(dataObj.picture)">
                                <img :src="$store.state.imgUrl + dataObj.picture" alt="">
                            </div>
                            <div class="imgTxt">个人照片</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="centerBox" v-if="filePaths.length">
                <div class="p1">其他照片附件：</div>
                <div class="p2">
                    <div class="imgW" v-for="(item, index) in filePaths" :key="index">
                        <div class="imgss" @click="bigImg(item)">
                            <img :src="$store.state.imgUrl + item" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <el-dialog title="" :visible.sync="centerDialogVisible" width="30%" center>
                <div class="bigImg">
                    <img :src="$store.state.imgUrl + imgUrlStr" />
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="centerDialogVisible = false">关 闭</el-button>
                </span>
            </el-dialog>
            <el-dialog title="注意" :visible.sync="tipsFlag" width="30%" center>
                <span v-html="content"></span>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="goEdit">继续编辑</el-button>
                    <el-button type="primary" @click="tipsFlag = false">退出编辑</el-button>
                </span>
            </el-dialog>
        </div>
        <div class="noData" v-else>
            <img src="@/assets/img/quesheng2.png" alt="">
            <div @click="goWholesaler">注册医师</div>
        </div>
    </div>

</template>

<script>
export default {
    name: "wholesalerInfo",
    data() {
        return {
            dataObj: {},
            medicalPractitionerCertificateImgList: [],
            authorizationImgList: [],
            physicianCardImgList: [],
            imgUrlStr: '',
            centerDialogVisible: false,
            tipsFlag: false,
            content: '',
            filePaths: [],//其他图片
        };
    },
    methods: {
        //医师信息回显
        getData() {
            let that = this;
            let params = {};
            let url = "/physician/getPhysician";
            that.$http
                .post(url, params)
                .then(res => {
                    res = res.data;
                    if (res.code == 200) {
                        this.dataObj = {
                            realName: res.data.realName,
                            phone: res.data.phone ? that.decrypt(res.data.phone, '6TuKlX4mwNflf95I') : '',
                            email: res.data.email ? that.decrypt(res.data.email, '6TuKlX4mwNflf95I') : '',
                            card: res.data.card ? that.decrypt(res.data.card, '6TuKlX4mwNflf95I') : '',
                            physicianCardNum: res.data.physicianCardNum,
                            city: res.data.city,
                            address: res.data.address,
                            hospital: res.data.hospital,
                            department: res.data.department,
                            title: res.data.title,
                            introduceMyself: res.data.introduceMyself,
                            adeptDepartments: res.data.adeptDepartments,
                            adeptDepartment: res.data.adeptDepartment,
                            cardFront: res.data.cardFront,
                            cardReverse: res.data.cardReverse,
                            peopleCardFront: res.data.peopleCardFront,
                            peopleCardReverse: res.data.peopleCardReverse,
                            physicianCardImg: res.data.physicianCardImg,
                            picture: res.data.picture,
                            approvalStatus: res.data.approvalStatus,
                            cityRegion: res.data.cityRegion,
                            opinion: res.data.opinion
                        };
                        that.dataObj.sex = that.getGenderByIdCard(that.dataObj.card);
                        // that.dataObj.cityRegion = res.data.city.split(",");
                        const result = [];
                        let arr = JSON.parse(res.data.adeptDepartment);
                        for (let i = 0; i < arr.length; i++) {
                            result.push(arr[i].value)
                        }
                        this.dataObj.adeptDepartments = result.join();
                        that.physicianCardImgList = res.data.physicianCardImg ? res.data.physicianCardImg.split(',') : [];
                        that.filePaths = res.data.filePaths ? res.data.filePaths.split(',') : [];//其他图片

                    } else {
                        that.$message.error(res.msg);
                    }
                })
                .catch(() => {
                });
        },
        getGenderByIdCard(idCard) {
            if (idCard.length === 18) {
                // 对于 18 位身份证号，第 17 位为性别位，奇数为男，偶数为女
                const genderCode = parseInt(idCard.charAt(16));
                if (genderCode % 2 === 0) {
                    return '女';
                } else {
                    return '男';
                }
            } else if (idCard.length === 15) {
                // 对于 15 位身份证号，第 15 位为性别位，奇数为男，偶数为女
                const genderCode = parseInt(idCard.charAt(14));
                if (genderCode % 2 === 0) {
                    return '女';
                } else {
                    return '男';
                }
            } else {
                throw new Error('Invalid ID card number length.');
            }
        },
        bigImg(img) {
            this.imgUrlStr = img;
            this.centerDialogVisible = true;
        },
        edit() {
            if (this.dataObj.approvalStatus == 1) {
                this.content = `    您当前已具备医师的身份资格。但请注意，若您决定修改相关资料，系统将自动引导您进入审核中心重新进行审核流程。此审核过程预计耗时1-3个工作日。在此期间，您的医师资格将暂时失效，直至审核成功通过后方可恢复。提交完成后，需要您重新登录。请问，您是否确定要继续前往进行资料编辑?`
            } else if (this.dataObj.approvalStatus == 2) {
                this.content = `    请注意，若您决定修改相关资料，系统将自动引导您进入审核中心重新进行审核流程。此审核过程预计耗时1-3个工作日。在此期间，您的医师资格将暂时失效，直至审核成功通过后方可恢复。提交完成后，需要您重新登录。请问，您是否确定要继续前往进行资料编辑?`
            }
            this.tipsFlag = true;
        },
        goEdit() {
            this.$router.push({
                path: "/ysRegister",
                query: { type: "edit" }
            });
        },
        goWholesaler() {
            this.$router.push({
                path: "/ysRegister"
            });
        }
    },
    created() {
        this.getData();
        let that = this;
        if (sessionStorage.getItem("userInfo")) {
            this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
        }
    }
};
</script>
<style scoped>
.center-box{
    margin-bottom: 10px;
}
.wrap {
    position: relative;
    width: 100%;
    height: 100%;
    background: #fff;
    box-sizing: border-box;
    padding: 30px 20px;
}

.topBtn {
    position: absolute;
    right: 135px;
    top: 30px;
}

.topBox {
    width: 100%;
}

.topBox::after {
    content: "";
    display: block;
    overflow: hidden;
    visibility: hidden;
    clear: both;
}

.org {
    color: #f64420;
    font-weight: 600;
    font-size: 16px;
}

.topBox-p {
    height: 30px;
    line-height: 30px;
    box-sizing: border-box;
    content: "";
    display: table;
    clear: both;
    width: 100%;
}

.topBox-p .p1 {
    float: left;
    text-align: right;
    width: 100px;
}

.topBox-p .p2 {
    float: left;
    width: calc(100% - 100px);
}

.topBox-p .p3 {
    float: left;
    color: #f64420;
    position: absolute;
    right: 130px;
    top: 30px;
}

.topBox-p .p3 .img1 {
    width: 100px;
}

.topBox-p .p4 {
    float: left;
    color: #f64420;
    position: absolute;
    right: 150px;
    top: 57px;
}

.topBox-p .p4 .img1 {
    width: 50px;
}

.topBox-p .p5 {
    float: left;
    color: #f64420;
    position: absolute;
    right: 143px;
    top: 57px;
}

.topBox-p .p5 .img1 {
    width: 100px;
}

.centerBox {
    width: 100%;
    margin-top: 10px;
}

.centerBox::after {
    content: '';
    display: block;
    overflow: hidden;
    visibility: hidden;
    clear: both;
}

.centerBox .p1 {
    width: 100px;
    float: left;
    text-align: right;
}

.centerBox .p2 {
    float: left;
    width: 700px;
}

.centerBox .p2 .imgWs {
    width: 100%;
    height: 100%;
}

.centerBox .p2 .imgWs .imgW {
    width: 40%;
    float: left;
    margin-right: 20px;
}

.centerBox .p2 img {
    width: 100%;
    height: 180px;
}

.centerBox .p2 .imgTxt {
    text-align: center;
    margin-top: 8px;
    height: 30px;
}

.bigImg {
    width: 100%;

}

.bigImg img {
    width: 100%;
    height: auto;
}

.noData {
    width: 100%;
    min-height: 545px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.noData img {
    width: 417.42px;
    height: 310.94px;
    margin-bottom: 20px;
}

.noData div {
    width: 417px;
    height: 38px;
    line-height: 38px;
    text-align: center;
    color: #fff;
    background-color: #f64420;
}

.imgss {
    float: left;
    width: 35%;
    height: 180px;
    overflow: hidden;
    margin: 0 20px 20px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/JW/doctorInfo.vue